import { Vue, Component, Watch, Prop, Inject, Provide } from 'vue-property-decorator';
import style from './style.vue';

@Component({
  mixins: [style],
})
export default class WeiGroup extends Vue {
  @Prop({ default: () => { } })
  value: DisplayWeiGroupData;

  @Prop({ default: 1 })
  themeCode: number;

  @Inject({
    default: () => {
      return () => {
        return { selected: -1 };
      };
    },
  })
  render(h) {
    return (
      <div class="show-window">
        <div class="window-case-nav width-100 r-mb-8">
          {(this.value as DisplayWeiGroupData).desc.weiGroupList.map((v, i) => {
            return (
              <div class="window-case-tab" style={`color: ${i === 0 ? '' : '#999999'}`}>
                {v.title}
                {i === 0 && <div class="under-line"></div>}
              </div>
            );
          })}
        </div>
        <div class="big-pri window-list">
          <div class="window-item flex column justify-center items-center font-size-14 font-bold">
            <div>{this.value.desc.weiGroupList.length ? (this.value as DisplayWeiGroupData).desc.weiGroupList[0]._pageName : ''}</div>
          </div>
        </div>
      </div>
    );
  }
}
